import { Close } from '@mui/icons-material'
import { Box, Dialog, Grid, IconButton, useTheme } from '@mui/material'
import CustomTypography from 'components/Fileds/CustomTypography'
import React from 'react'
import AddNewSlotForm from '../AddTimeSlots/AddNewSlotForm'
import { useGetTimeSlotsCategoryQuery } from 'pages/timeSlots/services'
import { useGetVendorTimingsQuery } from 'pages/restaurantTimings/services'
import RestaurantTimingHeader from '../AddTimeSlots/RestaurantTimingHeader'

const EditTimeSlots = ({ open, onClose, editData }) => {
    const theme = useTheme();
    const { data: categoryList, loading } = useGetTimeSlotsCategoryQuery();
    const { data: vendorTimings } = useGetVendorTimingsQuery();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            className="generic-dialog-container"
            PaperProps={{ sx: { borderRadius: '20px', padding: '10px', paddingBottom: '20px', color: 'black' } }}
        >
            <Box className='d-flex align-items-center justify-content-center' sx={{ m: 0, p: 2 }}>
                <IconButton aria-label="close" onClick={onClose} className='close-icon-container'>
                    <Close />
                </IconButton>
            </Box>
            <Box sx={{ px: 4, pt: 0, pb: 0 }}>
                <RestaurantTimingHeader vendorTimings={vendorTimings?.data} />
            </Box>
            <Box sx={{ mb: 2 }}>
                <CustomTypography
                    variant="h6"
                    label={"Edit Time Slot"}
                    sx={{
                        textAlign: 'center', mb: 0,
                        fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main
                    }}
                />
            </Box>
            <AddNewSlotForm
                categories={categoryList?.data?.records}
                editData={editData}
                handleCloseModal={onClose}
                vendorTimings={vendorTimings?.data}
            />
        </Dialog>
    )
}

export default EditTimeSlots
